import React from "react";

const InfoIcon = (props) => (
  <div className="InfoIcon">
    <div className="InfoIcon1" />
    <div className="InfoIcon2" />
  </div>
)

export default InfoIcon;